import * as React from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

function SelectTeachersDialog({ onClose, onOK, open, teachers,  }) {
  const [_selectedTeachers, setSelectedTeachers] = React.useState([]);

  useEffect(() => {
    // console.log('h');
    // if (selectedTeachers != null && selectedTeachers.length > 0) {
    //   console.log('here');
    //   setSelectedTeachers(selectedTeachers);
    // } else {
    //   setSelectedTeachers([]);
    // }
  }, []);

  const handleClose = () => {
    onClose();
  };

  const handleOK = () => {
    onOK(_selectedTeachers);
  };

  const handleSelect = (value) => {
    setSelectedTeachers(value);
  }

  return (
    <Dialog
    PaperProps={{
      sx: {
        maxHeight: 400
      }
    }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle>
        Select Teacher(s)
      </DialogTitle>

      <DialogContent>
        <InputLabel>Search and Select Teacher(s)</InputLabel>
        <Select options={teachers} onChange={handleSelect} isMulti={true} />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleOK}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectTeachersDialog;
